import React, { useEffect, useRef, useState } from "react";
import { fetchreviewlist } from "../services/Homereviewlist";
import { API_BASE } from "../api/apiConfig";

const MoHomereviewlist = () => {
  const [meetups, setMeetups] = useState([]);
  const [activeCountry, setActiveCountry] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const sliderRef = useRef(null);

  useEffect(() => {
  const loadData = async () => {
    const res = await fetchreviewlist(); // ✅ correct function
    if (res?.status && Array.isArray(res.data)) {
      setMeetups(res.data);
    }
  };
  loadData();
}, []);



  return (
    <section className="px-4 mb-10 pb-6 border-b border-slate-100">
      <div className="text-center mb-5">
          <h3 className="text-xl font-bold text-slate-800 mb-1">
          What Our Travelers Say
          </h3>
          <p className="text-xs text-slate-600">
          Real experiences from our community
          </p>
      </div>
      <div className="flex gap-3 pb-2 scrollbar-custom">

    {meetups.map((item) => {
      const expert = item.local_experts_details?.[0]; // ✅ yaha define karo

      return (
          <div key={item.id} className="flex-shrink-0 w-72">
          <div className="rounded-lg bg-card text-card-foreground mobile-card border-0 shadow-md overflow-hidden">
              <div className="relative h-40">
              <img
                  alt={item.title}
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover"
                  style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0
                  }}
                  src={`${API_BASE}/${item.image}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
              <div className="absolute top-2 right-2 bg-amber-500 text-white text-xs px-2 py-1 rounded-full flex items-center gap-1 font-bold">
                  <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 fill-current"
                  >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  {item.review}
              </div>
              <div className="absolute bottom-2 left-2 right-2">
                  <p className="text-xs text-white/90 font-medium mb-0.5">
                  {item.title}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-white/80">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-3 w-3"
                  >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                  </svg>
                  <span>{item.city}</span>
                  </div>
              </div>
              </div>
              <div className="p-3">
              <p className="text-xs text-slate-600 mb-3 line-clamp-3">
                  {item.comment}
              </p>
          {expert && (
              <div className="flex items-center gap-2">
                  <div className="relative w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
                  <img
                      alt={expert.name}
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                      }}
                      src={
                      expert.profileImage
                        ? `${API_BASE}/${expert.profileImage}`
                        : `${API_BASE}/default.jpg`
                    }
                    onError={(e) =>
                      (e.currentTarget.src = `${API_BASE}/default.jpg`)
                    }
                  />
                  </div>
                  <div className="min-w-0 flex-1">
                  <p className="text-xs font-semibold text-slate-800">
                      {expert.name}
                  </p>
                  <p className="text-xs text-slate-500">{expert.city}</p>
                  </div>
              </div>
            )}
              </div>
          </div>
          </div>
      );
      })}


      </div>
  </section>
  );
};

export default MoHomereviewlist;
